import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./modules/auth/auth-guard.service";
import { TemporaryPasswordGuardService } from "./modules/auth/temporary-password.guard";
import { ProvisionUserComponent } from "./modules/padlock/provision-user/provision-user.component";
import { UserNavComponent } from "./modules/user/user-nav/user-nav.component";
import { WorkspaceNavComponent } from "./modules/workspace/workspace-nav/workspace-nav.component";
import { WorkspacesComponent } from "./modules/workspace/workspaces/workspaces.component";

export enum AppRoutes {
  ROOT = "",
  WORKSPACE = "workspace",
  USER = "user",
  PROVISION_USER = "create-user",
}

const routes: Routes = [
  {
    path: AppRoutes.ROOT,
    component: WorkspacesComponent,
    canActivate: [AuthGuardService, TemporaryPasswordGuardService],
  },
  {
    path: AppRoutes.WORKSPACE,
    component: WorkspaceNavComponent,
    loadChildren: () =>
      import("./modules/workspace/workspace.module").then(
        (m) => m.WorkspaceModule,
      ),
    canActivate: [AuthGuardService, TemporaryPasswordGuardService],
    canActivateChild: [AuthGuardService, TemporaryPasswordGuardService],
  },
  {
    path: AppRoutes.USER,
    component: UserNavComponent,
    loadChildren: () =>
      import("./modules/user/user.module").then((m) => m.UserModule),
    canActivate: [AuthGuardService, TemporaryPasswordGuardService],
    canActivateChild: [AuthGuardService, TemporaryPasswordGuardService],
  },
  {
    path: AppRoutes.PROVISION_USER,
    component: ProvisionUserComponent,
    canActivate: [AuthGuardService, TemporaryPasswordGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: "reload" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
